import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import {
  Button,
  CircularProgress,
  InputAdornment,
  MenuItem,
  TextField,
} from '@mui/material';

import Breadcrumb from '@/components/breadcrumb';

import { useReception } from './use-reception';

export const ReceptionSection = () => {
  const hooks = useReception();

  const isBusy = hooks.isLoadingPo || hooks.isValidating;

  return (
    <div className="p-6 flex flex-col gap-4 pb-12">
      <Breadcrumb
        sections={[{ label: 'Izzi' }, { label: 'Recepción de inventario' }]}
        description="Carga una orden de compra y escanea los números de serie para validarlos con Izzi"
      />

      <div className="w-full max-w-5xl mx-auto flex flex-col gap-6">
        <div className="flex gap-4 items-start">
          <TextField
            label="Identificador de PO"
            variant="outlined"
            fullWidth
            required
            value={hooks.poId}
            onChange={hooks.onChangePoId}
            onKeyDown={hooks.onKeyDownPoId}
            onBlur={hooks.onBlurPoId}
            placeholder="Ingrese el identificador de PO"
            disabled={isBusy}
            autoFocus
          />
          <Button
            variant="contained"
            onClick={hooks.onLoadPo}
            disabled={isBusy || !hooks.poId.trim()}
            sx={{ minWidth: 130, height: 56, mt: 0 }}
          >
            {hooks.isLoadingPo ? <CircularProgress size={22} color="inherit" /> : 'Cargar PO'}
          </Button>
        </div>

        <TextField
          select
          label="SKU"
          variant="outlined"
          fullWidth
          required
          value={hooks.sku || ''}
          onChange={hooks.onChangeSku}
          disabled={isBusy || !hooks.isPoLoaded}
          helperText={
            hooks.isLoadingPo
              ? 'Cargando productos de la PO...'
              : hooks.isPoLoaded && hooks.poItems.length === 0
                ? 'La PO no tiene productos disponibles'
                : undefined
          }
        >
          <MenuItem value="" disabled>
            Seleccione un SKU
          </MenuItem>
          {hooks.poItems.map((item) => (
            <MenuItem key={item.sku} value={item.sku}>
              {item.productName} ({item.sku}) — {item.scannedCount}/{item.quantity}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Número de serie"
          variant="outlined"
          fullWidth
          required
          value={hooks.serialNumber}
          onChange={hooks.onChangeSerialNumber}
          onKeyDown={hooks.onKeyDownSerialNumber}
          placeholder="Escanee o ingrese el número de serie"
          disabled={!hooks.canScan}
          inputRef={hooks.serialInputRef}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <QrCodeScannerIcon color={hooks.canScan ? 'primary' : 'disabled'} />
              </InputAdornment>
            ),
            endAdornment: hooks.isValidating ? (
              <InputAdornment position="end">
                <CircularProgress size={20} />
              </InputAdornment>
            ) : undefined,
          }}
        />
      </div>
    </div>
  );
};

export default ReceptionSection;
